// src/analytics/RouteAnalytics.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track } from "./tracker";

export default function RouteAnalytics() {
  const loc = useLocation();

  useEffect(() => {
    track("page_view", { title: document.title || null });
  }, [loc.pathname, loc.search]);

  return null;
}
